import type { ApolloError } from '@apollo/client';
import { metrics } from '@seek/metrics-js';

import { isGraphQLAuthError } from '../error-handling/error-handling';

import { urlToTag } from './url-to-tag';

export const requestMetrics = ({
  duration,
  status,
  response: { url },
}: {
  duration: number;
  status: number;
  response: { url: string };
}) => {
  metrics.timing('api', duration, [
    `request-path:${urlToTag(url)}`,
    `status-code:${status}`,
  ]);
};

const buildTags = ({
  status,
  name,
}: {
  status: 'success' | 'failure';
  name: string;
}) => [`operation_name:${name}`, `status:${status}`];

export const sendApolloErrorMetrics = ({
  type,
  name,
  error,
}: {
  type: 'query' | 'mutation';
  name: string;
  error: ApolloError;
}) => {
  if (!isGraphQLAuthError(error)) {
    const tags = buildTags({ status: 'failure', name });
    metrics.count(type, tags);
  }
};
